import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubmissionCard = ({ submission, onCheckStatus, checkingStatus }) => {
  const navigate = useNavigate();

  return (
    <div 
      className={`bg-white rounded-lg shadow-md p-4 ${submission.in_history ? 'bg-gray-50' : ''}`}
      onClick={() => navigate(`/submissions/${submission.id}`)}
    >
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium text-gray-900">{submission.name}</p>
          <p className="text-sm text-gray-500">{submission.grading_service_name} - #{submission.submission_number}</p>
          {submission.order_number && <p className="text-sm text-gray-500">Order #: {submission.order_number}</p>}
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-500 flex items-center justify-end gap-1">
            Coins: {submission.coins?.length || 0}
            {submission.coin_mismatch && (
              <span title="Coin count mismatch detected">
                <svg className="w-4 h-4 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </span>
            )}
          </p>
          {submission.grading_service_name === 'PCGS' && (
            <button
              type="button"
              className="mt-2 px-2 py-1 text-xs font-medium text-indigo-600 hover:text-indigo-900 disabled:opacity-50 border border-indigo-600 rounded hover:bg-indigo-50"
              onClick={(e) => {
                e.stopPropagation();
                onCheckStatus(submission.id);
              }}
              disabled={checkingStatus[submission.id]}
            >
              {checkingStatus[submission.id] ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-600 mr-2"></div>
                  Checking...
                </div>
              ) : (
                'Update'
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubmissionCard;
